import { useState, useEffect} from "react";
import propTypes from "prop-types";
import LogoImg from "../assets/logo_BCHtagline.svg";
import Popup from "./Popup";
import webRootContext from "../components/webrootcontext/WebRootContext";

const Footer = (props) => {
  
console.log("In Footer:", props);
//console.log("In Footer version info:", props.version);  
const [versionInformation, setVersionInformation] = useState();
const versionUrl = webRootContext + "/rest/version/information";  

    
	useEffect(()=>{
    	fetch(versionUrl).then(response => response.text())
   			.then((response) => {
//       			console.log("Version info:", response);
        		setVersionInformation(response);
    	})
    
	}, [versionUrl]) // <-- empty dependency array
    
    
  return (
	<div>
	    <div className="footer">
	      <img src={LogoImg} alt="BCH Logo" />
	      <div>{props.applicationName}</div>
	      <div>
	        {/* this need pass in the version and link */}      
	         <a href="#versionInformationPopup">Version {props.version}</a>  &copy; {props.copyRight} All Rights Reserved
	      </div>
      </div>

    <Popup
        id="versionInformationPopup"
        title="Version Information"
        messageNormal={versionInformation}
    />      
    </div>
  );
};

// in case nothing is passed in
Footer.defaultProps = {
  version: "Version 1.0"
};
// in case nothing is passed in
Footer.defaultProps = {
  versionLink: "https://www.childrenshospital.org/"
};

// set version type to string, and make it required
Footer.propTypes = {
  version: propTypes.string.isRequired
};
// set versionLink type to string, and make it required
Footer.propTypes = {
  versionLink: propTypes.string.isRequired
};

export default Footer;
